import {TMS_OVERRIDES} from '../serve/consts';
import {get, remove, set} from '../serve/localStorage';

type TmsOverrides = {
  hash: string;
  translates: Record<string, string>;
  lang: string;
  uuid: string;
};

export function getTmsOverrides() {
  return get<TmsOverrides>(TMS_OVERRIDES);
}

export function setTmsOverrides(overrides: TmsOverrides) {
  return set(TMS_OVERRIDES, overrides);
}

export function removeTmsOverrides() {
  return remove(TMS_OVERRIDES);
}
